import React from 'react'
import { LayoutContext } from './LayoutContext'
import './RightSider.css'
export const RightSider = ({
  children
}) => {
  return (
    <LayoutContext.Consumer>
      {({ rightInner }) => (
        <div className="RightSider">
          {rightInner || null}
          {children}
        </div>
      )}
    </LayoutContext.Consumer>
  )
}
